import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=5c9663a0"
import script from "./theme.vue?vue&type=script&lang=ts"
export * from "./theme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports